const users = {
  pageName: 'Benutzer',
  mainTabs: {
    titleInvitations: 'Einladungen',
    titleExistingUsers: 'Vorhandene Benutzer',
  },
  headerButtons: {
    invite: {
      inviteBtn: 'Einladen',
    },
  },
  toast: {
    error: {
      default: 'Unbekannter Fehler ist aufgetreten.',
      badResponse: 'Benutzer: Ungültige Serverantwort',
      create: {},
      edit: {
        change: 'Falsches altes Passwort',
      },
      unauthorized: 'Vorgang nicht autorisiert.',
    },
    success: {
      delete: {
        default: 'Benutzer erfolgreich gelöscht',
      },
      create: {
        default: 'Der Benutzer wurde erfolgreich erstellt.',
      },
      edit: {
        change: 'Passwort geändert',
        default: 'Vom Benutzer aktualisiert.',
      },
      reset: {
        default: 'Die E-Mail zum Zurücksetzen des Passworts wurde erfolgreich gesendet.',
      },
    },
  },

  deleteModal: {
    header: 'Benutzer löschen',
    body: 'Sie sind dabei, {{num}} Benutzer zu löschen.',
  },

  create: {
    alreadyExistToast: {
      message: 'Es ist ein Fehler aufgetreten. Die E-Mail-Adresse ist bereits vorhanden. Bitte versuchen Sie es mit einer anderen E-Mail-Adresse.',
    },
    errorRequestToast: {
      message: 'Verboten. Sie haben keine Berechtigung, diese Aktion auszuführen. Bitte wenden Sie sich an einen Administrator.',
    },
    successToast: {
      message: 'Erfolg! Benutzer erfolgreich erstellt',
    },
    validations: {
      firstName: 'Vorname ist erforderlich',
      lastName: 'Nachname ist erforderlich',
      phone: {
        invalid: 'Telefon ist ungültig',
        required: 'Telefon ist erforderlich',
        length: 'Die Telefonnummer sollte 6 bis 16 Ziffern enthalten',
      },
      email: {
        required: 'E-Mail ist erforderlich',
        email: 'Ungültige E-Mail-Adresse',
      },
      role: {
        required: 'Rolle ist erforderlich',
      },
      supplier: {
        required: 'Anbieter ist erforderlich',
      },
    },
  },
  select: 'Wählen',
  edit: {
    modalRemoveConfirm: {
      header: 'Warnung!',
      body: 'user will be removed from current site only.,Möchten Sie diesen Benutzer wirklich löschen? Hinweis: Wenn er mit anderen Bereichen verknüpft ist, wird der Benutzer nur vom aktuellen Bereich entfernt., user will be removed from current site only.',
      modalRemoveConfirmBtn: 'Löschen',
    },
    formTabs: {
      informationTab: 'Information',
      notesTab: 'Hinweise',
      historyTab: 'Geschichte',
    },
  },

  table: {
    filters: {
      role: 'Rolle',
    },
    headers: {
      name: 'Name',
      email: 'E-Mail',
      phone: 'Telefon',
      role: 'Rolle',
    },
    actions: {
      delete: 'Löschen',
      export: 'Exportieren',
    },
    toolTip: {
      noPermission: 'Aktion nicht zulässig: Berechtigung erforderlich',
    },
  },
  isCompanyAdmin: 'Firmenadministrator',

  form: {
    header: {
      createUser: {
        title: 'Erstellen',
      },

      updateUser: {
        title: 'Aktualisieren',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Einreichen',
        update: 'Einreichen',
      },
    },

    selectOption: {
      select: 'Wählen',
    },
    information: {
      details: {
        header: 'Persönliche Daten',
        fields: {
          firstName: 'Vorname',
          lastName: 'Nachname',
          name: 'Name',
          phone: 'Telefon',
          email: 'E-Mail',
          site: 'Bereich',
        },
      },
      roles: {
        header: 'Bereiche und Rollen',
        fields: {
          role: 'Rolle',
          site: 'Bereich',
        },
        buttons: {
          addAccess: 'Bereich hinzufügen',
        },
      },
      actions: {
        header: 'Aktionen',
        buttons: {
          delete: 'Löschen',
          resetPassword: 'Passwort zurücksetzen',
          changePassword: 'Kennwort ändern',
        },
      },
    },
    valdations: {
      firstName: 'Vorname ist erforderlich',
      lastName: 'Nachname ist erforderlich',
      phone: 'Telefon ist erforderlich',
      supplier: 'Anbieter ist erforderlich',
      role: 'Rolle ist erforderlich',
      email: {
        required: 'E-Mail ist erforderlich',
        email: 'Ungültige E-Mail-Adresse',
      },
    },
  },
};

export default users;
